import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllClientProject } from "src/thunks/clientProjects";
import _ from "lodash";
import { Search, Close } from "@mui/icons-material";
import { isDropdownOpenFlag } from "src/thunks/dashboard";
import { Tooltip } from "@mui/material";



export const TypeDropDown = ({
    handleChange,
    clientGoodsInDropdownValue,
}) => {
    const dispatch = useDispatch();
    const lookupValues = useSelector((state) => state.lookup);
    let filterData = _.filter(lookupValues?.data, (d) => d?.typeName === "ItemStorageType")

    const filteredArrayForClients = _.map(filterData, (d) => {
        return {
            name: d?.name, value: d?.id
        }
    })

    const [filteredData, setFilteredData] = useState([]);
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef(null);
    const [searchValue, setSearchValue] = useState("");

    useEffect(() => {
        let dataShown = _.orderBy(filteredArrayForClients, ['name'], ["dsc"])
        setFilteredData([...dataShown])
    }, [lookupValues])

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        dispatch(getAllClientProject());
    }, []);

    useEffect(() => {
        dispatch(isDropdownOpenFlag(open));
    }, [open]);

    const onElementClicked = (item) => {
        handleChange(item);
        setOpen((prevOpen) => !prevOpen);
    };
    const onButton = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClearSearchText = () => {
        handleSearchInputChange({ target: { value: "" } });
    };

    const handleSearchInputChange = (e) => {
        setSearchValue(e.target.value)
        const searchTerm = e.target.value.toLowerCase();
        if (searchTerm === '') {
            let d = _.orderBy(filteredArrayForClients, ['name'], ["dsc"])
            setFilteredData([...d])
        } else {
            const filtered = filteredData.filter((item) => item.name.toLowerCase().includes(searchTerm));
            let data = _.orderBy(filtered || [], ['name'], ["dsc"])
            setFilteredData([...data]);
        }
    };

    return (
        <div style={{ flex: 1, color: "white" }}>
            <div ref={dropdownRef}>
                <div className="wrapper">
                    <div
                        className="button d-flex flex-row justify-content-between"
                        onClick={() => onButton()}
                    >
                        <Tooltip title={clientGoodsInDropdownValue.name == "ALL CLIENTS" ? "" : <span className="project-dropdown-tooltip-style1 project-dropdown-tooltip-style">{`${clientGoodsInDropdownValue.name}`}</span>} arrow>
                            <span className="projectname-wrap depot-dropdown-value-style" style={{
                                textTransform: "uppercase"
                            }}>
                                {clientGoodsInDropdownValue.name}
                            </span>
                        </Tooltip>
                        {open ? (
                            <span>
                                <i className="bi bi-chevron-up chevron-up-arrow"></i>
                            </span>
                        ) : (
                            <span>
                                <i className="bi bi-chevron-down chevron-down-arrow"></i>
                            </span>
                        )}
                    </div>
                    {open && (
                        <>
                            <div className={`content`}>
                                <div style={{ position: "relative", background: "#0045d9" }}>
                                    <input
                                        style={{ position: "relative", width: "100%" }}
                                        className="search-field-input"
                                        type="text"
                                        placeholder="Search by name..."
                                        value={searchValue}
                                        onChange={handleSearchInputChange}
                                    />
                                    {searchValue !== "" ? (
                                        <Close
                                            style={{ cursor: "pointer" }}
                                            onClick={handleClearSearchText}
                                            className="search-icon-depotpersonal-style"
                                        />
                                    ) : (
                                        <Search className="search-icon-depotpersonal-style" />
                                    )}
                                </div>

                                {[...filteredData].map((item, index) => {
                                    return (
                                        <div
                                            key={index}
                                            className={
                                                clientGoodsInDropdownValue?.name === item.name ? `selected-dropdownfield` : ""
                                            }
                                            style={{ textTransform: "uppercase" }}
                                            onClick={() => onElementClicked(item)}
                                        >
                                            {item.name}
                                        </div>
                                    );
                                })}
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};
